import LiveCaller from '@/LiveCaller'

export function updateAvailability(payload) {
    return LiveCaller.request().put('/availability', payload)
}

export function updateCallState(payload) {
    return LiveCaller.request().put('/availability/call', payload)
}

export function updateEndpointCallState(endpointId, callState) {
    return LiveCaller.request().put('/availability/call', {
        endpoint_id: endpointId,
        call_state: callState,
    })
}

export function updateChatState(payload) {
    return LiveCaller.request().put('/availability/chat', payload)
}

export function getTeamStatuses() {
    return LiveCaller.request().get('/availability/team')
}

export function getAwayReasons() {
    return LiveCaller.request().get('/away-reasons')
}

export function createAwayReason(data) {
    return LiveCaller.request().post('/away-reasons', data)
}

export function updateAwayReason(id, data) {
    return LiveCaller.request().put(`/away-reasons/${id}`, data)
}

export function deleteAwayReason(id) {
    return LiveCaller.request().delete(`/away-reasons/${id}`)
}

export function reorderAwayReasons(ids) {
    return LiveCaller.request().put('/away-reasons/reorder', { ids })
}
